/** Normalize form text without changing inner spaces or name capitalization. */
export const normalizeSignupText = (value: unknown): string => (
    typeof value === 'string' ? value.trim() : ''
);

export const SIGNUP_WHITESPACE_PASSWORD_ERROR = 'Password cannot be only spaces';

// Check for a blank-looking password without changing the value used to log in.
export const isWhitespaceOnlyPassword = (value: string): boolean => (
    value.length > 0 && normalizeSignupText(value).length === 0
);
